"use client";

import ScrollReveal from "@/components/common/ScrollReveal";
import BorderedHeading from "@/components/common/BorderedHeading";
import Button from "@/components/common/Button";

export interface JobSection {
  title: string;
  items: string[];
}

export interface JobData {
  title: string;
  sections: JobSection[];
  closingNote: string;
  applyEmail: string;
}

interface JobDetailContentProps {
  data: JobData;
}

export default function JobDetailContent({ data }: JobDetailContentProps) {
  const { title, sections, closingNote, applyEmail } = data;

  return (
    <section className="w-full px-4 sm:px-6 lg:px-8 pt-2 pb-12">
      <div className="w-full max-w-[1300px] mx-auto">
        {sections.map((section, sectionIndex) => (
          <ScrollReveal key={section.title} direction="up" delay={sectionIndex * 80}>
            <div className="mb-8 md:mb-10">
              <BorderedHeading
                as="h2"
                variant="headline-4"
                className="text-white text-lg md:text-xl font-semibold mb-4"
              >
                {section.title}
              </BorderedHeading>
              <ul className="space-y-2">
                {section.items.map((item, index) => (
                  <li
                    key={index}
                    className="text-text-default text-[15px] leading-[26px] flex items-start gap-3"
                  >
                    <span
                      aria-hidden
                      className="mt-[10px] inline-block w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0"
                    />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        ))}

        <ScrollReveal direction="up" delay={sections.length * 80}>
          <p className="text-text-default text-[15px] leading-[26px] mb-10">{closingNote}</p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={sections.length * 80 + 80}>
          <div className="flex">
            <a href={`mailto:${applyEmail}?subject=Application for ${title}`}>
              <Button variant="fill" color="primary" type="button">
                Apply Now
              </Button>
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
